// extracted by mini-css-extract-plugin
module.exports = {"item":"ListItem_item_1Pyx7","title":"ListItem_title_YpDLx","content":"ListItem_content_WznmA","spinAround":"ListItem_spinAround_3_Dr6"};